export  const keys = {
    paypal: {
        sandbox: "AS9MW8fGSOBHYr4CIpI3XRFZ9whei3bm-9-if3HgaZ4-iF0rE-Vuk_o-qhKaJciYwFwlBszPr_0I2AYr",
        live: "AZFlCM2W8fteDwbhfRzeUtLWSgRCTcn8KXe-QGMSEIt6f7Wyo3GvwcwgYQCvM-kXTXHQxYIHmdPXwlXm"
    }
}